<template>
  <div class="quiz-result">
    <div class="content columns">
      <div class="title-col column col-12">
        <div class="title title-col__title desktop-hidden">
          <span class="title-col__text">
            Niezrównana zwyciężczyni
          </span>
        </div>
      </div>
      <div class="images-col column col-4 col-sm-12">
        <div class="thumbnail">
          <img :src="require('@/assets/images/pic-s2-niezrownana-zwyciezczyni.png')"
               alt="Segment" class=" img-responsive thumbnail-image" />
        </div>
      </div>
      <div class="description column">
        <div class="title title-col__title mobile-hidden">
          <span class="title-col__text">
            Niezrównana zwyciężczyni
          </span>
        </div>
        <div class="description__content">
          <p class="quote">
            "Każdy dzień to nowe wyzwanie do pokonania"
          </p>
          <p>
            Dla Ciebie życie to gra, a Ty grasz o pełną stawkę.
            Lubisz wyzwania, cele, progres. Jesteś tą osobą, która wstaje wcześniej niż inni,
            działa szybciej niż inni – i osiąga więcej niż większość.
            Nie dlatego, że musisz. Dlatego, że <strong>chcesz</strong>.
          </p>
          <p>
            Twoja energia jest zaraźliwa, a Twoja ambicja – inspirująca.
            Stawiasz wysoko poprzeczkę, sobie i innym.
            Ale nie po to, żeby oceniać – tylko po to, żeby pchać rzeczy do przodu.
            Tam, gdzie inni się boją, Ty już układasz plan działania.
          </p>
          <p>
            W relacjach jesteś lojalna wobec tych, którzy grają na podobnym poziomie.
            Szanujesz ludzi ambitnych, zdyscyplinowanych i odważnych.
            Cenisz jakość i efektywność – także w emocjach.
          </p>
          <p>
            Twoja supermoc? Sprawiasz, że inni zaczynają wierzyć, że też mogą zwyciężać.
          </p>
          <p>
            <strong>Twoje wartości:</strong> rozwój, rywalizacja, skuteczność<br/>
            <strong>Styl życia:</strong> intensywny, wyczynowy, zorientowany na cel<br/>
            <strong>W relacjach:</strong> lojalna, inspirująca, motywująca<br/>
            <strong>Supermoc:</strong> prowadzisz do zwycięstw – siebie i innych
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NiezrownanaZwyciezczyni',
};
</script>

<style scoped>
.title-col__text {
  color: var(--color-niezrownana) !important;
}
.thumbnail-image {
  border-radius: 900px;
}
.quiz-result .percentage__value {
  color: var(--color-niezrownana);
}
.quiz-result .quote {
  font-style: italic;
  font-weight: 600;
  font-size: 22px;
}
</style>
